import { readPrivateTradingJson, writePrivateTradingJson } from '../../lib/storage/privateTradingStorage';

export const JOURNAL_ENTRY_TAG_OVERRIDES_STORAGE_KEY = 'journal-entry.tag-overrides.v1';

export type JournalEntryTagOverrides = Record<string, string[]>;

export function normalizeJournalEntryTagOverrides(value: unknown): JournalEntryTagOverrides {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return {};

  return Object.entries(value as Record<string, unknown>).reduce<JournalEntryTagOverrides>((acc, [rawKey, rawTags]) => {
    const key = String(rawKey ?? '').trim();
    if (!key) return acc;

    const tags = Array.isArray(rawTags)
      ? rawTags.map((tag) => String(tag ?? '').trim()).filter(Boolean)
      : [];

    acc[key] = Array.from(new Set(tags));
    return acc;
  }, {});
}

export function loadJournalEntryTagOverrides(): JournalEntryTagOverrides {
  try {
    const raw = readPrivateTradingJson('journal-entry-tag-overrides', 'local', [JOURNAL_ENTRY_TAG_OVERRIDES_STORAGE_KEY]);
    if (!raw) return {};
    return normalizeJournalEntryTagOverrides(JSON.parse(raw));
  } catch {
    return {};
  }
}

export function saveJournalEntryTagOverrides(overrides: JournalEntryTagOverrides): void {
  try {
    writePrivateTradingJson('journal-entry-tag-overrides', JSON.stringify(normalizeJournalEntryTagOverrides(overrides)));
  } catch {}
}
